import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LoginService } from '../login/_service/login.service';
import { User } from '../login/_model/user.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-mktglayout',
  templateUrl: './mktglayout.component.html',
  styleUrls: ['./mktglayout.component.css'],
  providers: [DatePipe]
})
export class MktglayoutComponent implements OnInit {
    
  currentUser: User;
  currDate: Date;
  prevDate: Date;
  fromdate: string;
  uptodate: string;
  UnitName: string;

  constructor(private _authenticate: LoginService, private datepipe: DatePipe, private _service: LoginService) {
    this.currentUser = this._authenticate.currentUserValue;

    this.currDate = new Date();
    this.prevDate = new Date(this.currDate.getFullYear(), this.currDate.getMonth() - 1, 1);
    
    this.fromdate = this.datepipe.transform(this.prevDate, 'dd-MM-yyyy');
    this.uptodate = this.datepipe.transform(this.currDate, 'dd-MM-yyyy');

  }

  ngOnInit() {
    $(document).ready(function () {
      $(".main-menu > li").hover(function () {
        $(this).find(".sub-menu").fadeToggle();
      });
      $(".footer-btn").click(function () {
        $(".main-footer").toggleClass("active");
        $(this).find("i").toggleClass("active");
      });
      $("#nav-icon2").click(function () {
        $(".main-menu").fadeToggle();
        $(this).toggleClass('open');

      });
      
    });

    
    this.UnitName = localStorage.getItem('UnitName');
  }


  logoutUser() {
    this._service.LogoutUser();
  }
}
$(document).keydown(function (event) {
  if (event.keyCode == 123) { // Prevent F12
    return false;
  } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I
    return false;
  }
});


/* To Disable Inspect Element */
$(document).bind("contextmenu", function (e) {
  e.preventDefault();
});

$(document).keydown(function (e) {
  if (e.which === 123) {
    return false;
  }
});
